import styled from 'styled-components';

export const StyledStatistics = styled.section`
  /* stats */
  &.lt-stats.lt-unicef-stats {
    padding-top: 40px;
    padding-bottom: 60px;
    background-color: var(--color-blue);
    .lt-stats-wrapper {
      row-gap: 30px;
    }

    .lt-stats-wrapper .lt-stat {
      gap: 15px;
    }
    .lt-stats-wrapper .lt-stat img {
      width: 63px;
      height: 72px;
      margin-left: 20px;
      float: left;
    }
    @media (max-width: 768px) {
      .lt-stats-wrapper {
        padding: 0;
      }
    }
  }

  &.lt-stats.lt-unicef-stats .img-wrapper {
    padding-bottom: 60px;
  }
  &.lt-stats.lt-unicef-stats .title-wrapper {
    padding-bottom: 20px;
  }

  @media (min-width: 768px) {
    &.lt-stats.lt-unicef-stats {
      padding-top: 100px;
      padding-bottom: 120px;
    }
    .lt-unicef-stats-wrapper {
      row-gap: 30px;
    }
    &.lt-stats.lt-unicef-stats .img-wrapper {
      padding-bottom: 120px;
    }
    &.lt-stats.lt-unicef-stats .title-wrapper {
      padding-bottom: 40px;
    }
  }
  /* stats */
  &.lt-stats {
    padding: 120px 0 0;
  }
  @media (min-width: 768px) {
    &.lt-stats {
      padding-top: 160px;
    }
  }
  &.lt-stats .lt-stats-wrap {
    margin: 42px 0 0;
  }
  @media (min-width: 768px) {
    &.lt-stats .lt-stats-wrap {
      margin-bottom: 55px;
    }
  }
  @media all and (max-width: 991px) {
    &.lt-stats .lt-stats-wrap .col-6 {
      margin-bottom: 40px;
    }
  }
  &.lt-stats h3 {
    max-width: 500px;
    margin-bottom: 40px;
  }
  &.lt-stats .lt-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  @media (min-width: 992px) {
    &.lt-stats .lt-stat {
      margin-bottom: 0;
    }
  }
  &.lt-stats .lt-stat-inner {
    border-left: 1px solid var(--color-dark);
    padding: 0 10px 0 20px;
    flex: 1;
    text-align: left;
  }
  &.lt-stats .lt-stat strong {
    display: block;
    font-weight: 700;
    font-size: 30px;
    line-height: 36px;
    margin-bottom: 4px;
  }
  &.lt-stats .lt-stat p {
    line-height: 16px;
  }
`;
